import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePCrmInvoiceType, PCrmInvoiceType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<PCrmInvoiceType>
      useData={usePCrmInvoiceType}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
